export const THEMES = {
  dark: {
    panel: "bg-[#0e1120] text-white border-white/10",
    field: "w-full rounded-lg border border-white/15 bg-black/30 px-4 py-3 text-sm text-white placeholder:text-zinc-500 focus:outline-none focus:border-cyan-300",
    muted: "text-zinc-400",
    label: "text-xs tracking-[0.2em] text-zinc-400",
    btn: "grad-bg text-white rounded-full font-semibold",
    ghost: "border border-white/15 text-white rounded-full hover:bg-white/5",
    opt: "border-white/10 hover:border-white/30",
    sel: "border-cyan-300 bg-white/[0.06]",
    divider: "border-white/10",
    title: "font-display text-2xl font-bold",
  },
  light: {
    panel: "bg-[#f8efe8] text-[#1d1a17] border-[#b08a3e]/30",
    field: "w-full rounded-[4px] border border-[#b08a3e]/30 bg-white px-4 py-3 text-sm text-[#1d1a17] placeholder:text-[#8a8077] focus:outline-none focus:border-[#8a6a2c]",
    muted: "text-[#6b625b]",
    label: "font-jost text-xs tracking-[0.25em] text-[#8a6a2c]",
    btn: "bg-[#8a6a2c] text-white rounded-full font-jost tracking-[0.2em] hover:bg-[#1d1a17]",
    ghost: "border border-[#1d1a17]/20 text-[#1d1a17] rounded-full hover:bg-white",
    opt: "border-[#b08a3e]/30 bg-white/60 hover:bg-white",
    sel: "border-[#8a6a2c] bg-white",
    divider: "border-[#b08a3e]/30",
    title: "font-serif-lux text-3xl font-semibold",
  },
};

export const toNum = (p) => Number(String(p ?? "0").replace(/\./g, "").replace(",", ".")) || 0;
export const brl = (n) => Number(n || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
export const onlyDigits = (v) => String(v || "").replace(/\D/g, "");
export const maskCep = (v) => onlyDigits(v).slice(0, 8).replace(/^(\d{5})(\d)/, "$1-$2");
